import { GetPlayerGroupsParams, PlayerGroup } from '@img-arena/consoles-api-golf-pricing'
import { ddeApi } from '@/service/ddeApi'
import { MarketTypes } from '@/views/GolfPricing/Tournament/OddsData/constants'

import { createBaseTableStore } from '../table'
import { FetchApiArgs, FetchApiResponse } from '../table/table.types'

export const fetchApi = async (
  args: FetchApiArgs<GetPlayerGroupsParams, string, string>
): Promise<FetchApiResponse<PlayerGroup>> => {
  const { signal, additionalParams } = args

  if (!additionalParams?.competitionId) {
    return {
      content: [],
      totalElements: 0
    }
  }

  const tournamentId = additionalParams.competitionId
  const entryList = await ddeApi.endpoints.golf.tournaments.getEntryList(tournamentId, signal)

  const isThreeBall = additionalParams.marketType === MarketTypes.THREE_BALL

  const playerGroups: PlayerGroup[] = isThreeBall
    ? entryList.data.map((entry) => ({
        players: entry.players.map((player) => ({
          playerId: player.playerId,
          playerFullName: player.displayName
        }))
      }))
    : entryList.data.flatMap((entry) =>
        entry.players.map((player) => ({
          players: [
            {
              playerId: player.playerId,
              playerFullName: player.displayName
            }
          ]
        }))
      )

  const sortedPlayerGroups = playerGroups.sort((a, b) => {
    const nameA = a.players[0]?.playerFullName || ''
    const nameB = b.players[0]?.playerFullName || ''
    return nameA.localeCompare(nameB)
  })

  return {
    content: sortedPlayerGroups,
    totalElements: sortedPlayerGroups.length
  }
}

export const usePlayerGroupsStore = createBaseTableStore({
  storeName: 'DDE Golf Pricing - Player groups',
  fetchApi
})
